const Imdb = ({ name, link }) => {
    return (
        <div className="imdb-container">
            <a href={link} className="no-highlight imdb-link" target="_blank"><img src="/images/case-studies/IMDb_Logo_Rectangle_Gold.png" className="imdb-logo" />
                <span className="imdb-name">{name}</span>
            </a>
        </div>
    );
}

export default Imdb;